import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { API } from 'aws-amplify';
import orderBy from 'lodash/orderBy';
import React from 'react';
import { AppContext } from '../../contexts/app-context';
import { captureError } from '../../utils/capture-error';
import { ActionListItem } from './action-list-item';

const useStyles = makeStyles({
  list: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
});

export function ActionList() {
  // Contexts
  const {
    state: { notificationsData },
    dispatch,
  } = React.useContext(AppContext);
  // State
  const [updating, setUpdating] = React.useState(false);
  // Hooks
  const classes = useStyles();

  // Order notifications
  const data = orderBy(
    notificationsData.actions,
    ['Read', 'DateAdded'],
    ['asc', 'desc'],
  );

  // Unread actions
  const unreadActions = data.filter((i) => i.Read === '0');

  const handleReadAll = async () => {
    const body = {};
    const path = '/crm/contacts/notification/actions/markAllRead';
    try {
      setUpdating(true);
      // Marking all action notifications as read
      await API.post('DashboardAPI', path, { body });
      // Close the drawer
      dispatch({ type: 'TOGGLE_NOTIFICATIONS_DRAWER' });
    } catch (error) {
      setUpdating(false);
      captureError({ data: { error, request: { body, path } } });
    }
  };

  return (
    <div className={classes.list}>
      {unreadActions.length ? (
        <React.Fragment>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              size="small"
              color="primary"
              disabled={updating}
              onClick={handleReadAll}
            >
              {updating ? 'Marking as read...' : 'Mark all as read'}
            </Button>
          </div>

          <Divider />
        </React.Fragment>
      ) : null}

      {data.length ? (
        <div style={{ flex: 1, overflowY: 'scroll' }}>
          {data.map((item) => {
            return <ActionListItem key={item.NId} item={item} />;
          })}
        </div>
      ) : (
        <Typography align="center" style={{ color: '#9b9b9b', paddingTop: 20 }}>
          No new actions needed!
        </Typography>
      )}
    </div>
  );
}
